


































































































import { DomesticPostageFee } from "@/graphql/client";
import { Component, Ref, Emit, Mixins } from "vue-property-decorator";
import domesticPostageFeeService from "@/service/domesticPostageFeeService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";
import MixinValidator from "@/components/mixins/domestic_postage_fee/MixinDomesticPostageFeeEditDialogValidator.vue";
import MixinFormatter from "@/components/mixins/MixinFormatter.vue";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class DomesticPostageFeeEditDialog extends Mixins(
  MixinFormatter,
  MixinValidator
) {
  @Ref() readonly itemForm!: HTMLFormElement;
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: DomesticPostageFee =
    domesticPostageFeeService.defaultDomesticPostageFee;
  valid = false;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  /**
   * 「YYY-MM-DD HH:mm:ss」形式の登録日時を取得
   */
  get formattedCreatedAt(): string {
    return this.formatDateTime(this.item.createdAt);
  }
  /**
   * 「YYY-MM-DD HH:mm:ss」形式の更新日時を取得
   */
  get formattedUpdatedAt(): string {
    return this.formatDateTime(this.item.updatedAt);
  }
  //---------------------------
  // methods
  //---------------------------
  async fetchData(item: DomesticPostageFee): Promise<void> {
    this.item = domesticPostageFeeService.defaultDomesticPostageFee;
    if (item.guid) {
      const result = await domesticPostageFeeService.getDomesticPostageFee(
        item.guid
      );
      if (result) {
        this.item = result;
      }
    }
  }
  /**
   * ダイアログを表示します.
   */
  public async open(item: DomesticPostageFee): Promise<void> {
    await this.fetchData(item);

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  save(): void {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.isProgressing = true;
      if (this.item.guid) {
        //update
        domesticPostageFeeService
          .updateDomesticPostageFee(this.item)
          .then((result) => {
            this.isProgressing = true;
            this.notifyUpdateSuccess(result as DomesticPostageFee);
          })
          .catch((err) => {
            console.error(err);
            this.notifyError("地域別送料の更新ができませんでした.");
          });
      } else {
        //create
        domesticPostageFeeService
          .createDomesticPostageFee(this.item)
          .then((result) => {
            this.isProgressing = true;
            this.notifyCreateSuccess(result as DomesticPostageFee);
          })
          .catch((err) => {
            console.error(err);
            this.notifyError("地域別送料の登録ができませんでした.");
          });
      }
    }
  }

  /**
   * 登録成功
   */
  @Emit("onCreateSuccess")
  public notifyCreateSuccess(created: DomesticPostageFee): DomesticPostageFee {
    return created;
  }
  /**
   * 更新成功
   */
  @Emit("onUpdateSuccess")
  public notifyUpdateSuccess(updated: DomesticPostageFee): DomesticPostageFee {
    return updated;
  }
  /**
   * 失敗
   */
  @Emit("onError")
  public notifyError(message: string): string {
    return message;
  }
}
